<mat-card
  fxFlex
  class="square-card mat-elevation-z0"
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <h4 class="square-card-title">{{ title }}</h4>
  <div class="dashboard-value" #valueElement>{{ value }}</div>
</mat-card>
